<script>
  import {Radar, mixins} from 'vue-chartjs'
  import ChartDataLabels from 'chartjs-plugin-datalabels';
  export default {
    extends: Radar,
    components: {
      ChartDataLabels,
    },
    mixins: [mixins.reactiveProp],
    props: ['options'], // chartData added by the reactiveProp
    name: "radarChart",
    mounted() {
      this.renderChart(this.chartData, this.options)
    },
  }
</script>

<style scoped>
</style>
